
document.addEventListener("DOMContentLoaded", function () {
  function bindDiscountHandler() {
    const applyBtn = document.getElementById("apply-discount-button");
    const input = document.getElementById("cart-discount-code");
    const message = document.getElementById("discount-message");
    const loader = document.getElementById("discount-loader");

    if (applyBtn && input && message) {
      applyBtn.addEventListener("click", function () {
        const discountCode = input.value.trim();
        if (!discountCode) {
          message.textContent = "Please enter a discount code.";
          message.className = "text-red-600 text-sm mt-2";
          return;
        }

        message.textContent = "";
        loader.classList.remove("hidden");

        // Use hidden iframe to apply discount without redirect
        let iframe = document.getElementById("discount-frame");
        if (!iframe) {
          iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.id = "discount-frame";
          document.body.appendChild(iframe);
        }

        iframe.onload = () => {
          // Once discount is applied via iframe, fetch updated cart drawer HTML
          fetch(`${window.location.pathname}?section_id=cart-drawer`)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newInner = doc.querySelector("cart-drawer .drawer__inner");
              const currentInner = document.querySelector("cart-drawer .drawer__inner");

              if (newInner && currentInner) {
                currentInner.innerHTML = newInner.innerHTML;

                message.textContent = `Discount "${discountCode}" applied!`;
                message.className = "text-green-600 text-sm mt-2";

                // Rebind your events if needed
                bindDiscountHandler();

                // Optional: re-init scripts if your theme needs it
                if (typeof reInitCartDrawer === "function") reInitCartDrawer();
              } else {
                throw new Error("Drawer inner content not found.");
              }
            })
            .catch((err) => {
              console.error("Discount error:", err);
              message.textContent = "Failed to apply discount. Try again.";
              message.className = "text-red-600 text-sm mt-2";
            })
            .finally(() => {
              loader.classList.add("hidden");
            });
        };

        // Trigger the iframe discount application
        iframe.src = `/discount/${discountCode}`;
      });
    }
  }

  bindDiscountHandler();
});









/*document.addEventListener("DOMContentLoaded", function () {
  function bindDiscountHandler() {
    const applyBtn = document.getElementById("apply-discount-button");
    const input = document.getElementById("cart-discount-code");
    const message = document.getElementById("discount-message");
    const loader = document.getElementById("discount-loader");

    if (applyBtn && input && message) {
      applyBtn.addEventListener("click", function () {
        const discountCode = input.value.trim();
        if (!discountCode) {
          message.textContent = "Please enter a discount code.";
          message.className = "text-red-600 text-sm mt-2";
          return;
        }

        message.textContent = "";
        loader.classList.remove("hidden");

        // STEP 1: Apply discount
        fetch(`/discount/${discountCode}`, {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
          },
        })
          .then(() => {
            // STEP 2: Fetch updated cart drawer
            return fetch(`${window.location.pathname}?section_id=cart-drawer`);
          })
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newDrawer = doc.querySelector("cart-drawer");

            if (!newDrawer) throw new Error("Cart drawer not found.");

            // Replace existing cart drawer
            document.querySelector("cart-drawer").replaceWith(newDrawer);

            // Rebind logic and show message
            bindDiscountHandler();
            message.textContent = `Discount "${discountCode}" applied!`;
            message.className = "text-green-600 text-sm mt-2";

            // ✅ Reopen the cart drawer
            if (typeof reInitCartDrawer === "function") reInitCartDrawer();

            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              // If it's a web component, call its `open()` method
              if (typeof cartDrawer.open === "function") {
                cartDrawer.open();
              } else {
                // Fallback: force it open with class (depends on your theme)
                cartDrawer.classList.add("active", "is-open");
                document.body.classList.add("js-drawer-open");
              }
            }
          })
          .catch((err) => {
            console.error("Discount error:", err);
            message.textContent = "Failed to apply discount. Try again.";
            message.className = "text-red-600 text-sm mt-2";
          })
          .finally(() => {
            loader.classList.add("hidden");
          });
      });
    }
  }

  bindDiscountHandler();
});*/
